import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { UserState } from '@core/user/user.state';
import { SnackBarService } from '@shared/components/snack-bar/snack-bar.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ResponseCodes, ResponseErrorCodes } from './response-codes';


export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const userState: UserState = inject(UserState);
    const snackBarService: SnackBarService = inject(SnackBarService);

    return next(req).pipe(catchError((error: HttpErrorResponse) => {
        switch (error.status) {
            case ResponseCodes.Unauthorized:
                userState.obsoleteToken();

                break;
            case ResponseCodes.BadRequest:
            case ResponseCodes.BadGateway:
            case ResponseCodes.GatewayTimeout:
            case ResponseCodes.ServiceUnavailable:
            case ResponseCodes.InternalServerError:
                if (ResponseErrorCodes.ErrNoUser === error.error.errorCode) {
                    snackBarService.open({
                        text: marker('snackbar.error.user-not-agent'),
                    })
                    userState.obsoleteToken();
                }

                break;
            default:
                break;
        }

        return throwError(error);
    }));
};
